import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDangerIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 12,
	height: 12,
	viewBox: "0 0 12 12",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M6 4.5V7",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5.99997 10.7046H2.96997C1.23497 10.7046 0.509966 9.46465 1.34997 7.94965L2.90997 5.13965L4.37997 2.49965C5.26997 0.894648 6.72997 0.894648 7.61997 2.49965L9.08997 5.14465L10.65 7.95465C11.49 9.46965 10.76 10.7096 9.02997 10.7096H5.99997V10.7046Z",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5.99731 8.5H6.00181",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgDangerIcon;
